/**!
 * Created by Leonardo Cheslacki on 20/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import {HelpersPin} from './../helpers';

import Big from 'big.js';

import config from '../../../../config';

const {default: {select, text}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class SupportSelect extends SupportController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: [] || {},
            pressed: false,
            invert: false,
            block: false,
            original: {
                occ_body: {
                    x: 0,
                    y: 0,
                    scale_x: 0,
                    scale_y: 0
                },
                occ_button: {
                    x: 0,
                    y: 0,
                    scale_x: 0,
                    scale_y: 0
                }
            },
            control: {
                big_moved_y: this.$controller.big_0,
                big_speed_y: this.$controller.big_0,
                big_pressed_y: this.$controller.big_0,
                big_scroll_down_y: this.$controller.big_0,
                big_scroll_up_y: this.$controller.big_0,
                big_button_down_y: this.$controller.big_0,
                big_button_up_y: this.$controller.big_0
            }
        };

        this.$plus = this.$controller.big_0;

        this.$isSelect = false;

        this.$supportTouchCanvas = null;

        this.$occBody = null;

        this.$occButton = null;

        this.$occIcon = null;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param big_button_friction
         */
        update: function (event, {big_button_friction}) {
            let
                {pressed, control} = _this.state,
                {friction} = _this.props,
                big_scroll_y = (new Big(_this.$occBody.y)),
                big_friction = (new Big(friction)),
                big_button_speed_y = control.big_speed_y.times(big_button_friction);

            pressed && (control.big_speed_y = control.big_moved_y.minus(control.big_pressed_y).plus(_this.$plus));

            control.big_pressed_y = control.big_moved_y;
            control.big_speed_y = control.big_speed_y.times(big_friction);

            if (big_scroll_y.lte(control.big_scroll_down_y)) {
                _this.moveOption(big_button_speed_y);
                _this.$occIcon.occ_up.gotoAndStop('enabled');
            }

            if (big_scroll_y.gte(control.big_scroll_up_y)) {
                _this.moveOption(big_button_speed_y);
                _this.$occIcon.occ_down.gotoAndStop('enabled');
            }

            if (!pressed) {
                if (big_scroll_y.gte(control.big_scroll_down_y)) {
                    _this.$occBody.y = _this.bigToNumber(control.big_scroll_down_y);
                    _this.$occButton.y = _this.bigToNumber(control.big_button_down_y);
                    _this.$occIcon.occ_up.gotoAndStop('disabled');
                }

                if (big_scroll_y.lte(control.big_scroll_up_y)) {
                    _this.$occBody.y = _this.bigToNumber(control.big_scroll_up_y);
                    _this.$occButton.y = _this.bigToNumber(control.big_button_up_y);
                    _this.$occIcon.occ_down.gotoAndStop('disabled');
                }
            }
        },

        /**
         *
         * @param big_clientY
         * @param invert
         */
        handleSelectMouseDown: function ({big_clientY}, invert) {
            _this.setState({..._this.state, pressed: true, invert: invert}, () => {
                _this.state.control.big_pressed_y = big_clientY;
                _this.state.control.big_moved_y = big_clientY;
            });
        },

        /**
         *
         * @param event
         * @param big_clientY
         * @param content
         */
        handleSelectPressMove: function (event, {big_clientY}) {
            //_this.testCoordinate(stage, big_clientX, big_clientY);

            const {control} = _this.state;
            control.big_moved_y = big_clientY;
        },

        /**
         *
         * @param big_clientX
         * @param big_clientY
         * @param invert
         */
        handleSelectTouchStart: function ({big_clientX, big_clientY}, invert) {
            const {_select, _select: {occ_option}, _option: {occ_form: {occ_thumb}}} = _this.props;

            let
                x = (new Big(_select.x).plus(new Big(occ_option.x))),
                y = (new Big(_select.y).plus(new Big(occ_option.y))),
                width_diff = -(occ_thumb.nominalBounds.width + _this.$occBody.x),
                height_diff = -(_this.$occBody.y - 3);

            if (_this.$supportTouchCanvas.checkLimitation(occ_option, big_clientX, big_clientY, x, y, width_diff, height_diff)) {
                _this.setState({..._this.state, pressed: true, invert: invert, block: false}, () => {
                    _this.state.control.big_pressed_y = big_clientY;
                    _this.state.control.big_moved_y = big_clientY;
                });
            }
        },

        /**
         *
         * @param event
         * @param big_clientX
         * @param big_clientY
         */
        handleSelectTouchMove: function (event, {big_clientX, big_clientY}) {
            _this.stopPropagation(event);

            const {_select, _select: {occ_option}, _option: {occ_form: {occ_thumb}}} = _this.props;

            //_this.testCoordinate(stage, big_clientX, big_clientY);

            let
                x = (new Big(_select.x).plus(new Big(occ_option.x))),
                y = (new Big(_select.y).plus(new Big(occ_option.y))),
                width_diff = -(occ_thumb.nominalBounds.width + _this.$occBody.x),
                height_diff = -(_this.$occBody.y - 3);

            if (_this.$supportTouchCanvas.checkLimitation(occ_option, big_clientX, big_clientY, x, y, width_diff, height_diff, 0)) {
                _this.state.control.big_moved_y = big_clientY;
            }
        },

        handleSelectResetUp: function ({type}) {
            if ((_this.state.block && (type === 'pressup') || (!_this.state.block && (type === 'touch')))) {
                _this.throttle('handleSelectResetUp', () => {
                    _this.setState({..._this.state, pressed: false}, () => {
                        _this.$plus = _this.$controller.big_0;
                    });
                }, 100);
            } else {
                _this.setState({..._this.state, pressed: false}, () => {
                    _this.$plus = _this.$controller.big_0;
                });
            }
        },

        /**
         *
         * @param event
         * @param invert
         * @param _this_btn
         */
        handleSelectButtonMouseDown: function (event, {invert, _this_btn}) {
            if (_this_btn.currentLabel === 'enabled') {
                _this.setState({..._this.state, pressed: true, invert: invert, block: true}, () => {
                    if (_this_btn.name === 'occ_up') {
                        _this.$plus = _this.$controller.big_20;
                    } else if (_this_btn.name === 'occ_down') {
                        _this.$plus = _this.$controller.big_20.neg();
                    }
                });
            }
        },

        /**
         *
         * @param event
         */
        handleSelectMouseOver: function (event) {
            // console.log(event);
        },

        /**
         *
         * @param event
         * @param text
         * @param value
         */
        handleSelect: function (event, {text, value}) {
            const
                {_this_class, _select} = _this.props,
                {occ_text: {occ_value}, occ_placeholder, occ_option} = _select,
                {placeholder, name} = _select.state;

            _this.clearErrors(name);

            occ_value.text = text;

            occ_placeholder.text = (occ_value.text ? '' : placeholder);

            _this_class.setStates({data: {[_this.toSlug(name, '_')]: value}});

            _this.$isSelect = false;

            occ_option.gotoAndPlay('complete');
        },

        /**
         *
         * @param event
         */
        handleOpenSelect: function (event) {
            const {_select: {occ_option}} = _this.props;

            if (!_this.$isSelect) {
                _this.$isSelect = true;
                occ_option.gotoAndPlay('start');
            } else {
                _this.$isSelect = false;
                occ_option.gotoAndPlay('complete');
            }
        }
    };

    clearErrors = (name) => {
        const {clearErrors, _select} = this.props;

        if (this.isFunction(clearErrors)) {
            clearErrors(name);
        } else {
            const {occ_error} = _select;
            occ_error.text = '';
        }
    };

    /**
     *
     * @param big_button_speed_y
     */
    moveOption = (big_button_speed_y) => {
        let {invert, control} = this.state;

        if (invert) {
            this.$occBody.y -= this.bigToNumber(control.big_speed_y);
            this.$occButton.y += this.bigToNumber(big_button_speed_y);
        } else {
            this.$occBody.y += this.bigToNumber(control.big_speed_y);
            this.$occButton.y -= this.bigToNumber(big_button_speed_y);
        }
    };

    cloneOption = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(_this)({current_name: 'options'}),

            /**
             *
             * @returns {null}
             */
            get optionText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set optionText(object) {
                this.object = object;
            },

            clone() {
                const {_this_layer: {content_option}} = _this.props;
                this.optionText = content_option.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             * @param capitalize
             */
            setText(string, color, font, size, weight, capitalize) {
                const {occ_text} = this.object;
                this.helpersPin.setText(occ_text, string, color, font, size, weight, null, null, capitalize);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param enabled
             * @param cursor
             */
            setCursor(enabled, cursor) {
                this.helpersPin.setCursor(_this, this.object, enabled, cursor);
            }
        }
    };

    /**
     *
     * @param height
     */
    scanControl = (height) => {
        const
            {original, control} = this.state,
            {_option: {occ_form}, _select, friction} = this.props,
            {content_body, occ_thumb} = occ_form,
            {stage, occ_size} = content_body,
            {occ_track} = occ_thumb;

        let
            big_scroll_height = (new Big(height)),
            big_size_height = (new Big(occ_size.nominalBounds.height)),
            big_track_height = (new Big(occ_track.nominalBounds.height)),
            body_scaleY = this.calcSize(big_size_height, big_scroll_height, 1, true),
            button_scaleY = this.calcSize(big_scroll_height, big_size_height, 1),
            big_button_height = this.calcSize(1, button_scaleY, (new Big(this.$occButton.nominalBounds.height)), true);

        if (body_scaleY.gt(this.$controller.big_1)) {
            control.big_scroll_down_y = (new Big(original.occ_body.y));
            control.big_scroll_up_y = big_size_height.plus(control.big_scroll_down_y).minus(big_scroll_height);

            control.big_button_down_y = (new Big(this.$occButton.y));
            control.big_button_up_y = big_track_height.plus(control.big_button_down_y).minus(big_button_height.plus(control.big_button_down_y.times(this.$controller.big_2)));

            let composition = this.getComposition(this.props.current_name);
            const {properties} = composition.getLibrary();

            const handle = (event, {type, state}) => {
                switch (type) {
                    case '_MOUSE_DOWN_':
                        this.$functions.handleSelectMouseDown(state, false);
                        break;
                    case '_MOUSE_MOVE_':
                        this.$functions.handleSelectPressMove(event, state);
                        break;
                    case '_TOUCH_START_':
                        this.$functions.handleSelectTouchStart(state, false);
                        break;
                    case '_TOUCH_MOVE_':
                        this.$functions.handleSelectTouchMove(event, state);
                        break;
                    case '_TOUCH_END_':
                        this.$functions.handleSelectResetUp(event);
                        break;
                    default:
                }
            };

            this.$supportTouchCanvas = this.main.$supportTouchCanvas({
                occ: _select,
                properties: properties,
                callback: handle
            });

            this.$supportTouchCanvas.initTouch();

            this.setHandleMouseDown(this.$occIcon.occ_up, this.$functions.handleSelectButtonMouseDown, {
                invert: true,
                _this_btn: this.$occIcon.occ_up
            });

            this.setHandleMouseDown(this.$occIcon.occ_down, this.$functions.handleSelectButtonMouseDown, {
                invert: true,
                _this_btn: this.$occIcon.occ_down
            });

            this.setHandleMouseDown(stage, this.$functions.handleSelectResetUp, null, 'select_reset_press_up', 'pressup');

            this.setHandleMouseDown(stage, this.$functions.handleSelectMouseOver, null, 'select_mouse_over', 'mouseover');

            this.destroyTicker('_handleTickerSelect');

            let ticker = createjs.Ticker.on('tick', this.$functions.update, false, false, {
                big_button_friction: this.calcSize(1, button_scaleY, friction, true)
            });

            this.setReferenceTicker('_handleTickerSelect', ticker);

            this.$occButton.setTransform(this.$occButton.x, this.$occButton.y, this.$occButton.scaleX, button_scaleY);
        }
    };

    /**
     *
     */
    defineSelect = () => {
        const
            {original} = this.state,
            {
                _this_class, form, _select,
                text: {font_size, font, weight}
            } = this.props,
            {occ_text: {occ_value: {x, lineWidth}}, occ_placeholder: {text}, name, occ_caret, occ_option} = _select;

        let
            state_name = this.verifyField(_select, 'state.name'),
            state_type = this.verifyField(_select, 'state.type'),
            state_value_x = this.verifyField(_select, 'state.value_x'),
            state_caret_x = this.verifyField(_select, 'state.caret_x'),
            state_line_width = this.verifyField(_select, 'state.line_width'),
            state_placeholder = this.verifyField(_select, 'state.placeholder');

        this.$isSelect = false;

        occ_option.gotoAndPlay('end');
        this.$occBody.y = original.occ_body.y;
        this.$occButton.y = original.occ_button.y;

        _select.occ_text.occ_value.text = '';
        _select.occ_text.occ_value.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${font_size}px '${font}'`;
        state_value_x && (_select.occ_text.occ_value.x = state_value_x);
        state_caret_x && (_select.occ_caret.x = state_caret_x);
        state_placeholder && (_select.occ_placeholder.text = state_placeholder);

        let
            named = this.toSlug(`${name.replace(`${form}_`, '')}_id`, '_'),
            typed = 'select';

        this.setStateOccurrence(_select, {
            name: state_name ? state_name : named,
            type: state_type ? state_type : typed,
            focus: false,
            value_x: state_value_x ? state_value_x : x,
            caret_x: state_caret_x ? state_caret_x : occ_caret.x,
            line_width: state_line_width ? state_line_width : lineWidth,
            placeholder: state_placeholder ? state_placeholder : text,
            tab_index: null,
            value: '',
            mask: ''
        });

        _this_class.$inputs[named] = _select;
    };

    startSelect = () => {
        const
            {data} = this.state,
            {
                _this_layer: {btn_select},
                text: {text_y, color_disabled, color_enabled, font, font_size, weight, capitalize}
            } = this.props;

        let y = 0;

        this.$occBody.removeAllChildren();

        this.recursiveSyncMap(data, 0, data.length, (item, next, stop, index) => {
            const
                text = this.verifyField(item, 'text'),
                value = this.verifyField(item, 'value'),
                selected = this.verifyField(item, 'selected'),
                option = this.cloneOption(this);

            let color_text = selected ? color_disabled : color_enabled;

            /**
             * Clone pin text
             */
            option.clone();

            /**
             * Clone pin text
             */
            option.setText(text, color_text, font, font_size, weight, capitalize);
            option.setCoordinate(0, y);

            if (!selected) {
                /**
                 * Clone pin text
                 */
                option.setCursor(true, 'pointer');

                let _index = this.padWithLeadingZeros(index, 2);

                /**
                 * Clone pin text to select with event click
                 */
                this[`_handleSelect${_index}`] && option.optionText.off('click', this[`_handleSelect${_index}`]);
                this[`_handleSelect${_index}`] = option.optionText.on('click', this.$functions.handleSelect, false, false, {
                    text: text,
                    value: value
                });
            } else {
                /**
                 * Clone pin text
                 */

                option.setCursor(false, 'default');
            }

            this.$occBody.addChild(option.optionText);

            y += text_y;

            next(true);
        }, () => {
            this.defineSelect();
            this.scanControl(y);
            this.setHandleMouseDown(btn_select, this.$functions.handleOpenSelect);
        });
    };

    initSelect = () => {
        const {data, _option} = this.props;

        this.$occBody = this.verifyField(_option, 'occ_form.content_body.occ_body');
        this.$occButton = this.verifyField(_option, 'occ_form.occ_thumb.occ_button');
        this.$occIcon = this.verifyField(_option, 'occ_form.occ_icon');

        this.setState({
            ...this.state,
            data: data,
            original: {
                occ_body: {
                    x: this.$occBody.x,
                    y: this.$occBody.y,
                    scale_x: this.$occBody.scaleX,
                    scale_y: this.$occBody.scaleY
                },
                occ_button: {
                    x: this.$occButton.x,
                    y: this.$occButton.y,
                    scale_x: this.$occButton.scaleX,
                    scale_y: this.$occButton.scaleY
                }
            }
        }, this.startSelect);
    };
}

/**
 *
 * @type {{}}
 */
SupportSelect.propTypes = {
    current_name: PropTypes.string,
    text: PropTypes.shape({
        text_x: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        text_y: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        color_enabled: PropTypes.string,
        color_disabled: PropTypes.string,
        font: PropTypes.string,
        font_size: PropTypes.number,
        weight: PropTypes.oneOf(['normal', 'bold'])
    })
};

/**
 *
 * @type {{}}
 */
SupportSelect.defaultProps = {
    current_name: null,
    ...select,
    text: {...select.text, ...text}
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportSelect, {className: 'SupportSelect'});
